var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeftWithLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 7.27995H4.32L7.84 3.67995C8.16 3.35995 8.16 2.87995 7.84 2.55995C7.52 2.23995 7.04 2.23995 6.72 2.55995L1.92 7.51995C1.6 7.83995 1.6 8.31995 1.92 8.63995L6.72 13.5999C6.88 13.7599 7.12 13.8399 7.28 13.8399C7.52 13.8399 7.68 13.7599 7.84 13.5999C8.16 13.2799 8.16 12.7999 7.84 12.4799L4.32 8.87995H13.6C14.08 8.87995 14.4 8.55995 14.4 8.07995C14.4 7.59995 14.08 7.27995 13.6 7.27995Z",
    fill: "#858894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWithLine);
export default __webpack_public_path__ + "static/media/arrow-left-with-line.0725152a97c82f2c64deb7852af3754b.svg";
export { ForwardRef as ReactComponent };